export const SPACING_CSS_PROPERTIES = ['gap', 'rowGap', 'columnGap', 'margin', 'marginTop', 'marginBottom', 'marginLeft', 'marginRight', 'padding', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight'];
export const SPACING_NONE = 'none';
export const SPACING_XSMALL = 'xSmall';
export const SPACING_SMALL = 'small';
export const SPACING_MEDIUM = 'medium';
export const SPACING_LARGE = 'large';
export const SPACING_XLARGE = 'xlarge';
const remBase = 16;
export const spacing = {
  [SPACING_NONE]: '0',
  [SPACING_XSMALL]: '0.25rem',
  [SPACING_SMALL]: '0.5rem',
  [SPACING_MEDIUM]: '1rem',
  [SPACING_LARGE]: '1.5rem',
  [SPACING_XLARGE]: '2.5rem'
};
export const parseToken = token => Number.parseFloat(spacing[token].replace('rem', '')) * remBase;